export const SCRIPTS_GIT_KEEP_FILE_SRC = [
  '# Scripts Directory',
  '',
  'Place custom build scripts, utilities (such as database migrations), and automation tools here.',
  '',
  'These scripts can use the @/ alias to import from src/:',
  '',
  '```typescript',
  "import { formatCount } from '@/libs/utils/format';",
  '```',
  '',
  'Run scripts with:',
  '',
  '```bash',
  'bun run scripts/your-script.ts',
  '```',
  '',
  'Or add a shortcut to package.json:',
  '',
  '```json',
  '"scripts": {',
  '  "script:name": "bun run scripts/your-script.ts"',
  '}',
  '```',
].join('\n');

export const LIBS_GIT_KEEP_FILE_SRC = [
  '# Libs Directory',
  '',
  'Shared libraries and utilities that can be used across apps, scripts, and other libs.',
  '',
  'Organize by feature or type:',
  '```',
  'src/libs/',
  '├── utils/          # General utilities',
  '├── hooks/          # React hooks',
  '├── components/     # Shared React components',
  '├── types/          # TypeScript types',
  '└── api/            # API clients',
  '```',
  '',
  'Import using the @/ alias:',
  '```typescript',
  "import { formatCount } from '@/libs/utils/format';",
  "import { useDebounce } from '@/libs/hooks/useDebounce';",
  '```',
].join('\n');

export const APPS_GIT_KEEP_FILE_SRC = [
  '# Apps Directory',
  '',
  'Each application lives in its own subdirectory with its own configuration.',
  '',
  'Create new apps using the unirend CLI:',
  '```bash',
  '# SSG (Static Site Generation)',
  'bunx unirend create ssg my-blog',
  '',
  '# SSR (Server-Side Rendering)',
  'bunx unirend create ssr my-app',
  '',
  '# API Server',
  'bunx unirend create api my-api',
  '```',
  '',
  'Apps can import from shared libs:',
  '```typescript',
  "import { formatCount } from '@/libs/utils/format';",
  "import { useDebounce } from '@/libs/hooks/useDebounce';",
  '```',
].join('\n');
